import React from 'react'
import { NewActionMatchingInterestsMetadata } from '../../../types/notifications'
import { ImageCircle, NotificationRowProps, NotificationRowShell } from './notification-row-shell'

const NewActionMatchingInterestsRow = (props: NotificationRowProps) => {
  const meta = props.notification.metadata as
    | Partial<NewActionMatchingInterestsMetadata>
    | undefined

  return (
    <NotificationRowShell
      {...props}
      avatar={<ImageCircle src={meta?.action_image} alt={meta?.action_name} />}
      destination={meta?.action_slug ? `/action/${meta.action_slug}` : undefined}
      highlights={[meta?.action_name]}
    />
  )
}

export default NewActionMatchingInterestsRow
